module.exports = __webpack_public_path__ + "img/youtube.34e80885.svg";